module.exports = __webpack_public_path__ + "static/img/s22.8150f796.png";